import type { FC } from 'react';
import React from 'react';

import Progressbar from '../../../components/ui/Progressbar';

interface IStepConfirmationProps {
  reset: () => void;
  resetButtonText?: string;
  error?: boolean;
}

const StepConfirmation: FC<IStepConfirmationProps> = ({
  reset,
  resetButtonText,
  error = false
}) => {
  return (
    <div className="box">
      <div className="box-content">
        <Progressbar reset={reset} resetButtonText={resetButtonText} error={error} />
      </div>
    </div>
  );
};

export default StepConfirmation;
